import axios, { AxiosResponse } from "axios";
import { inject, injectable } from "inversify";
import { API_ENDPOINTS } from "@infrastructure/InfrastructureConstants";
import { IUserRepository } from "@domain/repositories";
import { runtimeConfig } from "@utils/runtimeConfig/runtimeConfig";
import { ChangeMyPassword } from "@domain/schemas/BI";
import { TYPES } from "@utils/inversifyJS/types";
import type { IAuthenticatedRequestHandlerService } from "@application/contracts/services";

@injectable()
export class UserRepository implements IUserRepository {
  @inject(TYPES.IAuthenticatedRequestHandlerService)
  private _requestHandlerService!: IAuthenticatedRequestHandlerService;

  public async changeMyPassword(changeMyPasswordRequest: ChangeMyPassword): Promise<AxiosResponse> {
    const url = `${runtimeConfig.API_BASE_URL}${API_ENDPOINTS.changeCurrentUserPassword}`;
    return this._requestHandlerService.handleRequestAsync(() =>
      axios.put(url, changeMyPasswordRequest, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }),
    );
  }
}
